import { configureStore } from '@reduxjs/toolkit'
import optionsReducer from '../src/slices/optionsSlice'
import commonReducer from '../src/slices/commonSlice'

export const store = configureStore({
  reducer: {
    options: optionsReducer,
    all: commonReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch